module.exports = __webpack_public_path__ + "img/flologo.a6094df1.svg";